import * as React from 'react'
import type { SVGProps } from 'react'
const SvgUber = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.1367 12.855V8H1v4.916c0 1.8474 1.2548 3.0687 2.8787 3.0687.7972 0 1.491-.3206 2.0077-.8702v.7328h1.122V8H5.8715v4.855c0 1.2519-.812 2.0916-1.86 2.0916-1.063-.0153-1.8749-.8245-1.8749-2.0916m5.9936 3.0076H9.208v-.7176A2.71 2.71 0 0 0 11.186 16c1.6239 0 2.9083-1.3282 2.9083-2.9924s-1.2844-2.9923-2.9083-2.9923c-.7676 0-1.4614.3206-1.9634.8549V8H8.1303zm1.0777-2.855c0-1.1145.8562-1.9847 1.9043-1.9847s1.9044.8702 1.9044 1.9847c0 1.0993-.8562 1.9848-1.9044 1.9848-1.0629 0-1.9043-.8855-1.9043-1.9848m5.5359-.0152c0 1.7099 1.2843 2.9923 2.9377 2.9923 1.0039 0 1.8306-.458 2.3916-1.2213l-.7972-.6107c-.4134.5649-.9596.8397-1.5944.8397-.93 0-1.6829-.7023-1.8305-1.6336h4.5026v-.3664c0-1.71-1.1663-2.9771-2.7606-2.9771-1.6239 0-2.8492 1.3587-2.8492 2.9771m2.8196-1.9848c.812 0 1.4911.5802 1.683 1.4657h-3.3806c.2066-.8855.8857-1.4657 1.6976-1.4657M24 11.145v-1.0534h-.3838c-.6053 0-1.0482.2901-1.3287.7481v-.7023h-1.0629v5.7252h1.0925v-3.2672c0-.8855.5167-1.4656 1.24-1.4656H24z"
    />
  </svg>
)
export default SvgUber
